import { Component, OnInit } from '@angular/core';
import {Page} from '../../../shared/models/page.interface';
import {Templates} from '../../models/templates.interface';
import {TemplatesSearch} from '../../models/templates-search.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MessageService} from '../../../shared/services/message.service';
import {Router} from '@angular/router';
import {TemplatesService} from '../../services/templates.service';
import {Master} from '../../models/master.interface';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  templates!: Page<Templates>;
  templateCategories!: Master[];
  private search!: TemplatesSearch;
  private page: PageRequest = {page: 0, size: 100, sort: 'category.description', direction: 'asc'};
  constructor(private readonly templatesService: TemplatesService,
              private messageService: MessageService,
              private readonly router: Router) { }

  ngOnInit(): void {
    this.templatesService.getAll({status: 'ACTIVE'}, this.page).subscribe(
      data => this.templates = data
    );
    this.templatesService.getCategories().subscribe(
      data => this.templateCategories = data
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadTemplates(event: PageRequest): void {
    this.page = event;
    this.updateData();
  }

  searchTemplates(search: TemplatesSearch): void {
    this.search = search;
    if (Object.keys(search).length === 0) {
      this.page = {page: 0, size: 100, sort: 'category', direction: 'asc'};
    }
    this.templatesService.getAll(search, this.page).subscribe(
      data => this.templates = data
    );
  }

  updateTemplateStatus(id: number): void {
    this.templatesService.updateTemplate(id).subscribe(
      () => this.updateData()
    );
  }

  deleteTemplate(id: number): void {
    this.templatesService.deleteTemplate(id).subscribe(
      () => this.updateData()
    );
  }

  private updateData(): void {
    if (this.search) {
      this.templatesService.getAll(this.search, this.page).subscribe(
        data => this.templates = data
      );
    }
    else {
      this.templatesService.getAll({status: 'ACTIVE'}, this.page).subscribe(
        data => this.templates = data
      );
    }
  }

}
